import { StyleSheet, View } from '@react-pdf/renderer';
import React from 'react';

import { TableRowProps } from './Table.types';
import TableCell from './TableCell';

const styles = StyleSheet.create({
  tableRow: {
    flexDirection: 'row',
    borderWidth: 1,
    borderTopWidth: 0.5,
    borderRightWidth: 0,
    borderColor: '#bfbfbf',
    marginTop: -0.1,
  },
});
export default function TableRow({ columns, row, allData }: TableRowProps) {
  return (
    <View style={styles.tableRow} wrap={false}>
      {columns.map(({ field, renderCell, ...rest }, colIndex) => (
        <TableCell key={`${field}-${row.id}-${colIndex}`}>
          {renderCell?.({
            row,
            field,
            colDef: { field, renderCell, ...rest },
            value: row?.[field],
            allData: allData,
          }) ||
            row?.[field] ||
            ''}
        </TableCell>
      ))}
    </View>
  );
}
